import { useApp } from "@plugins/common/composables/app-composable.ts";

export interface MenuItem {
  showMenuItem: () => boolean;
  textKey: string;
  actionKey: string;
}

const { isAcpImageAppAvailable, isAcpHtml5AppAvailable } = useApp();

// To show richtext plugin (RichTextEditor.vue)
export const ACP_PLUGINS = [
  {
    key: "acp_all",
    showPlugin: () => isAcpHtml5AppAvailable.value || isAcpImageAppAvailable.value,
  },
  {
    key: "acp_image",
    showPlugin: () => isAcpImageAppAvailable.value,
  },
];

// Menu Items (plugin.ts)
const imageMenuItem: MenuItem = {
  showMenuItem: () => isAcpImageAppAvailable.value,
  textKey: "tinymce_plugin_acp_image_button_tooltip",
  actionKey: "openAcpImage",
};

const interactiveMenuItem: MenuItem = {
  showMenuItem: () => isAcpHtml5AppAvailable.value,
  textKey: "tinymce_plugin_acp_html5_interactive_button_tooltip",
  actionKey: "openAcpHtml5",
};

// Button Config
export const EDITOR_MENU_ITEMS: Record<string, (typeof imageMenuItem)[]> = {
  acp_all: [imageMenuItem, interactiveMenuItem],
  acp_image: [imageMenuItem],
};
